import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FiX } from 'react-icons/fi';
import { API_BASE, authHeaders, formatSgDateTime } from '../../utils/assetHelpers';

function DetailRow({ label, value }) {
    if (value == null || value === '') return null;
    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-1 py-2 border-b border-gray-100">
            <dt className="text-sm font-medium text-gray-500">{label}</dt>
            <dd className="sm:col-span-2 text-sm text-gray-900 break-words whitespace-pre-wrap">{value}</dd>
        </div>
    );
}

const ViewOtherAssetModal = ({ asset, onClose, onEdit }) => {
    const [detail, setDetail] = useState(asset || null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!asset?._id) return undefined;
        let cancelled = false;
        setLoading(true);
        axios.get(`${API_BASE}/api/assets/others/${asset._id}`, { headers: authHeaders() })
            .then((res) => { if (!cancelled && res.data.success) setDetail(res.data.data); })
            .catch((err) => { if (!cancelled) setError(err.response?.data?.error || err.message); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [asset?._id]);

    const display = detail || asset;
    const payment = display?.paymentObject || {};
    const cardExpiry = [payment.cardExpiry?.month, payment.cardExpiry?.year].filter(Boolean).join('/');

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
            <div className="bg-white rounded-lg p-6 w-full max-w-3xl my-8 min-w-0">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">View Other Asset</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700"><FiX className="w-6 h-6" /></button>
                </div>
                {error && <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-md">{error}</div>}
                {loading ? <p className="text-gray-600">Loading...</p> : (
                    <dl>
                        <DetailRow label="Asset Type" value={display?.assetType} />
                        <DetailRow label="Status" value={display?.status} />
                        <DetailRow label="Name" value={display?.name} />
                        <DetailRow label="Owned By" value={display?.ownedBy} />
                        <DetailRow label="Project Category" value={display?.projectCategory} />
                        <DetailRow label="In Cloudflare" value={display?.inCloudflare ? 'Yes' : 'No'} />
                        <DetailRow label="Login ID" value={display?.loginID} />
                        <DetailRow label="Login Password" value={display?.loginPass} />
                        <DetailRow label="Needs Payment" value={payment.needPayment ? 'Yes' : 'No'} />
                        <DetailRow label="Payment Type" value={payment.paymentType} />
                        <DetailRow label="Payment Card" value={payment.paymentCard} />
                        <DetailRow label="Card Expiry" value={cardExpiry} />
                        <DetailRow label="Remarks" value={display?.remarks} />
                        <DetailRow label="Created" value={formatSgDateTime(display?.createdAt)} />
                        <DetailRow label="Updated" value={formatSgDateTime(display?.updatedAt)} />
                    </dl>
                )}
                <div className="flex justify-end gap-3 mt-6">
                    {onEdit && display && (
                        <button type="button" onClick={() => onEdit(display)} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Edit</button>
                    )}
                    <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">Close</button>
                </div>
            </div>
        </div>
    );
};

export default ViewOtherAssetModal;
